// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   REWARDS & ACHIEVEMENTS STYLES
   ============================================ */

.rewards-page {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px 16px;
  color: #e0e0e0;
}

.rewards-title {
  font-size: 1.5rem;
  text-align: center;
  margin-bottom: 20px;
  color: #fff;
}

.rewards-loading {
  text-align: center;
  color: #9ca3af;
  padding: 40px 0;
}

/* Tabs */
.rewards-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  padding: 4px;
}

.rewards-tab {
  flex: 1 1;
  background: none;
  border: none;
  color: #9ca3af;
  padding: 10px 8px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 500;
  transition: all 0.2s;
}

.rewards-tab.active {
  background: rgba(124, 58, 237, 0.25);
  color: #c4b5fd;
}

/* Streak Card */
.streak-card {
  text-align: center;
  padding: 24px 16px;
  background: linear-gradient(135deg, rgba(124, 58, 237, 0.15), rgba(236, 72, 153, 0.1));
  border-radius: 16px;
  border: 1px solid rgba(124, 58, 237, 0.2);
  margin-bottom: 20px;
}

.streak-flame {
  font-size: 2.5rem;
  margin-bottom: 4px;
}

.streak-value {
  font-size: 3rem;
  font-weight: 800;
  color: #fff;
  line-height: 1;
}

.streak-label {
  font-size: 1rem;
  color: #c4b5fd;
  margin-top: 4px;
}

.streak-best {
  font-size: 0.8rem;
  color: #9ca3af;
  margin-top: 8px;
}

/* Reward Schedule (7-day cycle) */
.cycle-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.cycle-tag {
  font-size: 0.8rem;
  font-weight: 600;
  color: #c4b5fd;
  background: rgba(124, 58, 237, 0.15);
  padding: 4px 10px;
  border-radius: 20px;
}

.cycle-reward-tag {
  font-size: 0.8rem;
  font-weight: 600;
  color: #fbbf24;
}

.reward-schedule-7 {
  grid-template-columns: repeat(7, 1fr);
}

.reward-schedule {
  display: grid;
  gap: 8px;
  margin-bottom: 12px;
}

.reward-day {
  text-align: center;
  padding: 12px 6px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  transition: all 0.2s;
}

.reward-day.completed {
  background: rgba(5, 150, 105, 0.15);
  border-color: rgba(5, 150, 105, 0.3);
}

.reward-day.current {
  background: rgba(124, 58, 237, 0.2);
  border-color: rgba(124, 58, 237, 0.5);
  box-shadow: 0 0 12px rgba(124, 58, 237, 0.2);
}

.reward-day-num {
  font-size: 0.7rem;
  color: #9ca3af;
  margin-bottom: 4px;
}

.reward-day-icon {
  font-size: 1.3rem;
  margin-bottom: 2px;
}

.reward-day-amt {
  font-size: 0.7rem;
  font-weight: 700;
  color: #fbbf24;
}

.reward-day.payday {
  border-color: rgba(251, 191, 36, 0.35);
  background: rgba(251, 191, 36, 0.08);
}

.reward-day.payday.completed {
  background: rgba(5, 150, 105, 0.15);
  border-color: rgba(5, 150, 105, 0.3);
}

.cycle-hint {
  text-align: center;
  font-size: 0.78rem;
  color: #9ca3af;
  margin-bottom: 14px;
}

.claim-checkin {
  margin-top: 14px;
  text-align: center;
  padding: 12px;
  background: rgba(124, 58, 237, 0.08);
  border: 1px solid rgba(124, 58, 237, 0.15);
  border-radius: 12px;
  color: #c4b5fd;
  font-size: 0.9rem;
}

.claim-burst {
  position: relative;
  height: 0;
  pointer-events: none;
  opacity: 0;
  z-index: 0;
}

.claim-burst.active {
  opacity: 1;
}

.claim-burst__ring,
.claim-burst__spark {
  position: absolute;
  left: 50%;
  top: 14px;
  transform: translate(-50%, -50%) scale(0.25);
  opacity: 0;
}

.claim-burst.active .claim-burst__ring--one {
  width: 94px;
  height: 94px;
  border: 2px solid rgba(236, 72, 153, 0.55);
  border-radius: 999px;
  animation: claim-burst-ring 0.58s ease-out forwards;
}

.claim-burst.active .claim-burst__ring--two {
  width: 126px;
  height: 126px;
  border: 2px solid rgba(251, 191, 36, 0.4);
  border-radius: 999px;
  animation: claim-burst-ring 0.68s ease-out 0.04s forwards;
}

.claim-burst__spark {
  width: 56px;
  height: 4px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,230,180,0.95), rgba(255,255,255,0));
  box-shadow: 0 0 14px rgba(251, 191, 36, 0.45);
}

.claim-burst.active .claim-burst__spark--one {
  --spark-rot: 16deg;
  animation: claim-burst-spark 0.44s ease-out forwards;
  transform: translate(-50%, -50%) rotate(16deg) scale(0.2);
}

.claim-burst.active .claim-burst__spark--two {
  --spark-rot: -18deg;
  animation: claim-burst-spark 0.44s ease-out 0.03s forwards;
  transform: translate(-50%, -50%) rotate(-18deg) scale(0.2);
}

.claim-burst.active .claim-burst__spark--three {
  --spark-rot: 58deg;
  animation: claim-burst-spark 0.44s ease-out 0.06s forwards;
  transform: translate(-50%, -50%) rotate(58deg) scale(0.2);
}

.claim-burst.active .claim-burst__spark--four {
  --spark-rot: -58deg;
  animation: claim-burst-spark 0.44s ease-out 0.09s forwards;
  transform: translate(-50%, -50%) rotate(-58deg) scale(0.2);
}

/* Claim Button */
.claim-btn {
  display: block;
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #7c3aed, #ec4899);
  color: #fff;
  font-size: 1.05rem;
  font-weight: 700;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.claim-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.claim-btn:not(:disabled):active {
  transform: translateY(1px) scale(0.992);
}

.claimed-msg {
  text-align: center;
  padding: 14px;
  background: rgba(5, 150, 105, 0.1);
  border: 1px solid rgba(5, 150, 105, 0.2);
  border-radius: 12px;
  color: #6ee7b7;
  font-weight: 600;
}

.claim-success {
  margin-top: 16px;
  text-align: center;
  padding: 14px;
  background: rgba(124, 58, 237, 0.1);
  border: 1px solid rgba(124, 58, 237, 0.2);
  border-radius: 12px;
  color: #c4b5fd;
}

.new-achievements {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: center;
}

.new-ach-badge {
  background: rgba(255, 255, 255, 0.08);
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.8rem;
}

@keyframes claim-burst-ring {
  0% {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(0.2);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1.25);
  }
}

@keyframes claim-burst-spark {
  0% {
    opacity: 0.95;
    margin-left: 0;
  }
  100% {
    opacity: 0;
    margin-left: 0;
    transform: translate(-50%, -50%) rotate(var(--spark-rot, 0deg)) scale(1.2);
  }
}

/* Badges */
.badge-category {
  margin-bottom: 24px;
}

.badge-cat-title {
  font-size: 1rem;
  color: #c4b5fd;
  margin-bottom: 10px;
  text-transform: capitalize;
}

.badge-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 10px;
}

.badge-card {
  text-align: center;
  padding: 14px 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  transition: all 0.2s;
}

.badge-card.unlocked {
  background: rgba(5, 150, 105, 0.1);
  border-color: rgba(5, 150, 105, 0.25);
}

.badge-card.locked {
  opacity: 0.5;
}

.badge-icon {
  font-size: 2rem;
  margin-bottom: 6px;
}

.badge-name {
  font-size: 0.85rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 2px;
}

.badge-desc {
  font-size: 0.72rem;
  color: #9ca3af;
  margin-bottom: 4px;
}

.badge-reward {
  font-size: 0.72rem;
  color: #6ee7b7;
  font-weight: 600;
}

.badge-date {
  font-size: 0.68rem;
  color: #6b7280;
  margin-top: 4px;
}

/* History Table */
.history-table {
  width: 100%;
  border-collapse: collapse;
}

.history-table th,
.history-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  font-size: 0.85rem;
}

.history-table th {
  color: #9ca3af;
  font-weight: 600;
}

.no-history {
  text-align: center;
  color: #6b7280;
  padding: 24px 0;
}

/* Referral Dashboard */
.referral-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 24px;
}

.ref-stat-card {
  text-align: center;
  padding: 20px 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
}

.ref-stat-icon {
  font-size: 1.8rem;
  margin-bottom: 6px;
}

.ref-stat-value {
  font-size: 2rem;
  font-weight: 800;
  color: #fff;
}

.ref-stat-label {
  font-size: 0.8rem;
  color: #9ca3af;
  margin-top: 2px;
}

.referral-link-section {
  margin-bottom: 24px;
}

.referral-link-section h3 {
  font-size: 1rem;
  margin-bottom: 10px;
  color: #c4b5fd;
}

.referral-link-box {
  display: flex;
  gap: 8px;
}

.referral-link-input {
  flex: 1 1;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  color: #e0e0e0;
  padding: 10px 12px;
  font-size: 0.82rem;
  outline: none;
}

.referral-copy-btn {
  background: linear-gradient(135deg, #7c3aed, #6366f1);
  border: none;
  color: #fff;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
  transition: opacity 0.2s;
}

.referral-copy-btn:hover {
  opacity: 0.85;
}

.referral-code-display {
  font-size: 0.82rem;
  color: #9ca3af;
  margin-top: 8px;
}

.referral-info {
  font-size: 0.82rem;
  color: #6b7280;
  margin-top: 6px;
  line-height: 1.4;
}

.referral-users-section {
  margin-top: 12px;
}

.referral-users-section h3 {
  font-size: 1rem;
  margin-bottom: 10px;
  color: #c4b5fd;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Rewards.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sFAAsF;EACtF,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,oBAAoB;EACpB,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,oGAAoG;EACpG,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,oDAAoD;EACpD,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,0DAA0D;EAC1D,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,0DAA0D;EAC1D,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,0DAA0D;EAC1D,0DAA0D;AAC5D;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;IACZ,2CAA2C;EAC7C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,UAAU;IACV,cAAc;IACd,0EAA0E;EAC5E;AACF;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":["/* ============================================\n   REWARDS & ACHIEVEMENTS STYLES\n   ============================================ */\n\n.rewards-page {\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 20px 16px;\n  color: #e0e0e0;\n}\n\n.rewards-title {\n  font-size: 1.5rem;\n  text-align: center;\n  margin-bottom: 20px;\n  color: #fff;\n}\n\n.rewards-loading {\n  text-align: center;\n  color: #9ca3af;\n  padding: 40px 0;\n}\n\n/* Tabs */\n.rewards-tabs {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 20px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 10px;\n  padding: 4px;\n}\n\n.rewards-tab {\n  flex: 1;\n  background: none;\n  border: none;\n  color: #9ca3af;\n  padding: 10px 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.rewards-tab.active {\n  background: rgba(124, 58, 237, 0.25);\n  color: #c4b5fd;\n}\n\n/* Streak Card */\n.streak-card {\n  text-align: center;\n  padding: 24px 16px;\n  background: linear-gradient(135deg, rgba(124, 58, 237, 0.15), rgba(236, 72, 153, 0.1));\n  border-radius: 16px;\n  border: 1px solid rgba(124, 58, 237, 0.2);\n  margin-bottom: 20px;\n}\n\n.streak-flame {\n  font-size: 2.5rem;\n  margin-bottom: 4px;\n}\n\n.streak-value {\n  font-size: 3rem;\n  font-weight: 800;\n  color: #fff;\n  line-height: 1;\n}\n\n.streak-label {\n  font-size: 1rem;\n  color: #c4b5fd;\n  margin-top: 4px;\n}\n\n.streak-best {\n  font-size: 0.8rem;\n  color: #9ca3af;\n  margin-top: 8px;\n}\n\n/* Reward Schedule (7-day cycle) */\n.cycle-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.cycle-tag {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #c4b5fd;\n  background: rgba(124, 58, 237, 0.15);\n  padding: 4px 10px;\n  border-radius: 20px;\n}\n\n.cycle-reward-tag {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #fbbf24;\n}\n\n.reward-schedule-7 {\n  grid-template-columns: repeat(7, 1fr);\n}\n\n.reward-schedule {\n  display: grid;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.reward-day {\n  text-align: center;\n  padding: 12px 6px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  transition: all 0.2s;\n}\n\n.reward-day.completed {\n  background: rgba(5, 150, 105, 0.15);\n  border-color: rgba(5, 150, 105, 0.3);\n}\n\n.reward-day.current {\n  background: rgba(124, 58, 237, 0.2);\n  border-color: rgba(124, 58, 237, 0.5);\n  box-shadow: 0 0 12px rgba(124, 58, 237, 0.2);\n}\n\n.reward-day-num {\n  font-size: 0.7rem;\n  color: #9ca3af;\n  margin-bottom: 4px;\n}\n\n.reward-day-icon {\n  font-size: 1.3rem;\n  margin-bottom: 2px;\n}\n\n.reward-day-amt {\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: #fbbf24;\n}\n\n.reward-day.payday {\n  border-color: rgba(251, 191, 36, 0.35);\n  background: rgba(251, 191, 36, 0.08);\n}\n\n.reward-day.payday.completed {\n  background: rgba(5, 150, 105, 0.15);\n  border-color: rgba(5, 150, 105, 0.3);\n}\n\n.cycle-hint {\n  text-align: center;\n  font-size: 0.78rem;\n  color: #9ca3af;\n  margin-bottom: 14px;\n}\n\n.claim-checkin {\n  margin-top: 14px;\n  text-align: center;\n  padding: 12px;\n  background: rgba(124, 58, 237, 0.08);\n  border: 1px solid rgba(124, 58, 237, 0.15);\n  border-radius: 12px;\n  color: #c4b5fd;\n  font-size: 0.9rem;\n}\n\n.claim-burst {\n  position: relative;\n  height: 0;\n  pointer-events: none;\n  opacity: 0;\n  z-index: 0;\n}\n\n.claim-burst.active {\n  opacity: 1;\n}\n\n.claim-burst__ring,\n.claim-burst__spark {\n  position: absolute;\n  left: 50%;\n  top: 14px;\n  transform: translate(-50%, -50%) scale(0.25);\n  opacity: 0;\n}\n\n.claim-burst.active .claim-burst__ring--one {\n  width: 94px;\n  height: 94px;\n  border: 2px solid rgba(236, 72, 153, 0.55);\n  border-radius: 999px;\n  animation: claim-burst-ring 0.58s ease-out forwards;\n}\n\n.claim-burst.active .claim-burst__ring--two {\n  width: 126px;\n  height: 126px;\n  border: 2px solid rgba(251, 191, 36, 0.4);\n  border-radius: 999px;\n  animation: claim-burst-ring 0.68s ease-out 0.04s forwards;\n}\n\n.claim-burst__spark {\n  width: 56px;\n  height: 4px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,230,180,0.95), rgba(255,255,255,0));\n  box-shadow: 0 0 14px rgba(251, 191, 36, 0.45);\n}\n\n.claim-burst.active .claim-burst__spark--one {\n  --spark-rot: 16deg;\n  animation: claim-burst-spark 0.44s ease-out forwards;\n  transform: translate(-50%, -50%) rotate(16deg) scale(0.2);\n}\n\n.claim-burst.active .claim-burst__spark--two {\n  --spark-rot: -18deg;\n  animation: claim-burst-spark 0.44s ease-out 0.03s forwards;\n  transform: translate(-50%, -50%) rotate(-18deg) scale(0.2);\n}\n\n.claim-burst.active .claim-burst__spark--three {\n  --spark-rot: 58deg;\n  animation: claim-burst-spark 0.44s ease-out 0.06s forwards;\n  transform: translate(-50%, -50%) rotate(58deg) scale(0.2);\n}\n\n.claim-burst.active .claim-burst__spark--four {\n  --spark-rot: -58deg;\n  animation: claim-burst-spark 0.44s ease-out 0.09s forwards;\n  transform: translate(-50%, -50%) rotate(-58deg) scale(0.2);\n}\n\n/* Claim Button */\n.claim-btn {\n  display: block;\n  width: 100%;\n  padding: 14px;\n  background: linear-gradient(135deg, #7c3aed, #ec4899);\n  color: #fff;\n  font-size: 1.05rem;\n  font-weight: 700;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.claim-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.claim-btn:not(:disabled):active {\n  transform: translateY(1px) scale(0.992);\n}\n\n.claimed-msg {\n  text-align: center;\n  padding: 14px;\n  background: rgba(5, 150, 105, 0.1);\n  border: 1px solid rgba(5, 150, 105, 0.2);\n  border-radius: 12px;\n  color: #6ee7b7;\n  font-weight: 600;\n}\n\n.claim-success {\n  margin-top: 16px;\n  text-align: center;\n  padding: 14px;\n  background: rgba(124, 58, 237, 0.1);\n  border: 1px solid rgba(124, 58, 237, 0.2);\n  border-radius: 12px;\n  color: #c4b5fd;\n}\n\n.new-achievements {\n  margin-top: 10px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  justify-content: center;\n}\n\n.new-ach-badge {\n  background: rgba(255, 255, 255, 0.08);\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 0.8rem;\n}\n\n@keyframes claim-burst-ring {\n  0% {\n    opacity: 0.8;\n    transform: translate(-50%, -50%) scale(0.2);\n  }\n  100% {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(1.25);\n  }\n}\n\n@keyframes claim-burst-spark {\n  0% {\n    opacity: 0.95;\n    margin-left: 0;\n  }\n  100% {\n    opacity: 0;\n    margin-left: 0;\n    transform: translate(-50%, -50%) rotate(var(--spark-rot, 0deg)) scale(1.2);\n  }\n}\n\n/* Badges */\n.badge-category {\n  margin-bottom: 24px;\n}\n\n.badge-cat-title {\n  font-size: 1rem;\n  color: #c4b5fd;\n  margin-bottom: 10px;\n  text-transform: capitalize;\n}\n\n.badge-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 10px;\n}\n\n.badge-card {\n  text-align: center;\n  padding: 14px 10px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  transition: all 0.2s;\n}\n\n.badge-card.unlocked {\n  background: rgba(5, 150, 105, 0.1);\n  border-color: rgba(5, 150, 105, 0.25);\n}\n\n.badge-card.locked {\n  opacity: 0.5;\n}\n\n.badge-icon {\n  font-size: 2rem;\n  margin-bottom: 6px;\n}\n\n.badge-name {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 2px;\n}\n\n.badge-desc {\n  font-size: 0.72rem;\n  color: #9ca3af;\n  margin-bottom: 4px;\n}\n\n.badge-reward {\n  font-size: 0.72rem;\n  color: #6ee7b7;\n  font-weight: 600;\n}\n\n.badge-date {\n  font-size: 0.68rem;\n  color: #6b7280;\n  margin-top: 4px;\n}\n\n/* History Table */\n.history-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.history-table th,\n.history-table td {\n  padding: 10px 12px;\n  text-align: left;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  font-size: 0.85rem;\n}\n\n.history-table th {\n  color: #9ca3af;\n  font-weight: 600;\n}\n\n.no-history {\n  text-align: center;\n  color: #6b7280;\n  padding: 24px 0;\n}\n\n/* Referral Dashboard */\n.referral-stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.ref-stat-card {\n  text-align: center;\n  padding: 20px 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n}\n\n.ref-stat-icon {\n  font-size: 1.8rem;\n  margin-bottom: 6px;\n}\n\n.ref-stat-value {\n  font-size: 2rem;\n  font-weight: 800;\n  color: #fff;\n}\n\n.ref-stat-label {\n  font-size: 0.8rem;\n  color: #9ca3af;\n  margin-top: 2px;\n}\n\n.referral-link-section {\n  margin-bottom: 24px;\n}\n\n.referral-link-section h3 {\n  font-size: 1rem;\n  margin-bottom: 10px;\n  color: #c4b5fd;\n}\n\n.referral-link-box {\n  display: flex;\n  gap: 8px;\n}\n\n.referral-link-input {\n  flex: 1;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  color: #e0e0e0;\n  padding: 10px 12px;\n  font-size: 0.82rem;\n  outline: none;\n}\n\n.referral-copy-btn {\n  background: linear-gradient(135deg, #7c3aed, #6366f1);\n  border: none;\n  color: #fff;\n  padding: 10px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 600;\n  white-space: nowrap;\n  transition: opacity 0.2s;\n}\n\n.referral-copy-btn:hover {\n  opacity: 0.85;\n}\n\n.referral-code-display {\n  font-size: 0.82rem;\n  color: #9ca3af;\n  margin-top: 8px;\n}\n\n.referral-info {\n  font-size: 0.82rem;\n  color: #6b7280;\n  margin-top: 6px;\n  line-height: 1.4;\n}\n\n.referral-users-section {\n  margin-top: 12px;\n}\n\n.referral-users-section h3 {\n  font-size: 1rem;\n  margin-bottom: 10px;\n  color: #c4b5fd;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
